import React from 'react'
import { NextPage } from 'next'
import { PartnerDirectoryPage } from 'experiences/learn/partners/PartnerDirectoryPage'
import { getQueryParam, NamedPromises } from 'lib'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { getPartners } from 'services/ContentfulService/models/partner/hooks'
import { PartnerTypeConstraint } from 'services/ContentfulService/constraints'
import { getAllProducts } from 'services/ContentfulService/hooks/products'
import { Product } from 'services/ContentfulService/models/product'

interface Props {
	partners: Partner[]
	initialTopic: string | undefined
	products: Product[]
}

const Partners: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => (
	<StandardLayout metaTags={metaTags}>
		<PartnerDirectoryPage
			products={pageProps.products.sort((a, b) => a.sort - b.sort)}
			partners={pageProps.partners}
			initialTopic={pageProps.initialTopic}
		/>
	</StandardLayout>
)

export const getServerSideProps = getSEOServersideProps<Props>(ctx => {
	const initialTopic = ctx.query && ctx.query.topic ? getQueryParam(ctx.query.topic)[0] : undefined
	return NamedPromises({
		partners: getPartners({ constraints: [PartnerTypeConstraint('Demand')] }),
		products: getAllProducts(),
		initialTopic: Promise.resolve(initialTopic)
	})
})

export default Partners
